module.exports = __webpack_public_path__ + "img/Gateway Ping Icon.c45f0928.png";